<!--  -->
<template>
  <div class='video-view'>
    <div class="nav">
      <div class="title">《{{info.keshi_name}}》</div>
      <!-- <div>
        <span>播放倍速：</span>
        <el-input value="1.0" readonly style="width: 200px"></el-input>
      </div> -->
    </div>
    <div class="myVideo">
      <video id="myVideo" autoplay controls="controls" controlslist="noplaybackrate nodownload noremoteplayback disablePictureInPicture" disablePictureInPicture v-if="info.keshi_url" oncontextmenu="return false;" ondragstart="return false;">
        <source :src="info.keshi_url" type="video/mp4" />
        <source src="movie.ogg" type="video/ogg" /> 对不起，您的浏览器暂不支持video视频标签!
      </video>
    </div>
    <div class="quit" @click="handleQuit">返回上一页面</div>

    <kao-shi ref="kaoshi" @hideChange="hideChange"></kao-shi>

    <el-dialog
      :visible.sync="show"
      width="30%"
      top="15vh"
      :close-on-click-modal="false"
      :show-close="true"
      center>
      <template slot="title">
        <div style="color: #4CC08C;font-size: 20px;font-weight: bolder;">公需考试</div>
      </template>
      <div class="hint">
        <p>恭喜您已完成公需课学习！建议<span>先进行“模拟练习”</span>，再参加<span>“公需正式考试”</span>，<span>60分合格</span>，祝您顺利获取<span>10学分</span>。</p>
      </div>
      <span slot="footer">
        <el-button round type="success" class="self-button--success" size="medium" style="width: 110px" @click="$router.back()">我知道了</el-button>
        <el-button round type="warning" class="self-button--warning" size="medium" style="width: 110px" @click="handleLianxi">模拟练习</el-button>
        <el-button round type="primary" class="self-button--primary" size="medium" style="width: 110px" @click="handleKaoshi">进入考试</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KaoShi from './components/kaoshi/index.vue'
import Api from '../api/gongxu'

export default {
  components: {
    KaoShi
  },
  data() {
    return {
      info: {},
      currentTime: '',
      planTime: '',
      status: true,
      idx: 0,
      show: false,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getVideo()
    document.onkeydown = document.onkeyup = document.onkeypress = function(event) { 
      var e = event || window.event || arguments.callee.caller.arguments[0]; 
      if (e && e.keyCode == 123) { 
        e.returnValue = false; 
        return (false); 
      } 
    }
    document.oncontextmenu = new Function("return false;");
  },
  mounted() {
    
  },
  beforeDestroy () {
    document.onkeydown = document.onkeyup = document.onkeypress = () => {}
    document.oncontextmenu = () => {}
    if (this.info.finish == '1') {
      return
    }
    this.coursejilu(1)
    setTimeout(() => {
      window.οnbefοreunlοad = () => {}
    }, 500)
    clearInterval(this.planTime)
    let video = document.getElementById("myVideo")
    video.removeEventListener("pause", this.monitor_pause)
    video.removeEventListener("timeupdate", this.monitor_timeupdate)
    video.removeEventListener("ended", this.monitor_ended)
    video.removeEventListener("enterpictureinpicture", this.vidoe_forbid)
  },
  //方法集合
  methods: {
    vidoe_forbid (e) {
      e.preventDefault();
      if (document.pictureInPictureElement) {
        document.exitPictureInPicture();
      }
    },
    getVideo () {
      Api.getVideo({
        vid: this.$route.query.id,
        year: this.$route.query.year,
      }).then(res => {
        // res.data.data.tanti_time = [res.data.data.study_time+10, ...res.data.data.tanti_time]
        if (res.data.code != 1) {
          this.$message.error('视频详情获取失败')
          return
        }
        if (res.data.data.state == 0) {
          this.$message.warning('不可同时播放多个视频!')
          this.$router.back()
          return;
        }
        this.info = res.data.data
        if (this.info.finish == '1') {
          return;
        }
        this.currentTime = res.data.data.study_time
        this.$nextTick(() => {
          setTimeout(() => {
            let video = document.getElementById("myVideo")
            video.currentTime = this.currentTime
            video.play()
            video.removeEventListener("pause", this.monitor_pause)
            video.addEventListener("pause", this.monitor_pause)
            video.addEventListener('enterpictureinpicture', this.vidoe_forbid);
            window.addEventListener("beforeunload", (event) => {
							event.returnValue = '';
							this.coursejilu(1)
						}, false);
            if (this.info.tanti_time.indexOf(this.currentTime) != -1) {
              this.idx = this.info.tanti_time.indexOf(this.currentTime)
              video.pause()
              clearInterval(this.planTime)
              this.status = false
              this.$refs.kaoshi.init({
                id: this.$route.query.id,
                year: this.$route.query.year,
              })
              return;
            }
            this.playPlan()
            this.playOver()
            this.planTime = setInterval(() => {
              this.savePlayPlan()
            }, 60000)
          }, 200)
        })
      })
    },
    // 获取视频播放进度
    playPlan () {
      if (this.info.finish == '1') {
        return
      }
      var video = document.getElementById("myVideo");
      video.removeEventListener("timeupdate", this.monitor_timeupdate)
      video.addEventListener("timeupdate", this.monitor_timeupdate,false)
    },
    // 视频播放结束
    playOver () {
      if (this.info.finish == '1') {
        return
      }
      var video = document.getElementById("myVideo");
      video.removeEventListener("ended", this.monitor_ended)
      video.addEventListener("ended", this.monitor_ended)
    },
    // 保存播放进度
    savePlayPlan () {
      Api.savePlayPlan({
        id: this.$route.query.id,
        year: this.$route.query.year,
        jilu_id: this.info.jilu_id,
        study_time: this.currentTime
      }).then(res => {
        if (res.data.state == 0) {
          this.$message.warning('不可同时播放多个视频!')
          this.$router.back()
          return;
        }
      })
    },
    // 保存播放进度
    coursejilu (exit) {
      Api.coursejilu({
        jilu_id: this.info.jilu_id,
        year: this.$route.query.year,
        currentTime: this.currentTime,
        exit: exit || ''
      })
    },
    hideChange () {
      this.status = true
      this.info.tanti_time.splice(this.idx, 1)
      this.$nextTick(() => {
        let video = document.getElementById("myVideo")
        video.play()
        this.playPlan()
        this.playOver()
        this.savePlayPlan()
        let planTime = setInterval(() => {
          this.savePlayPlan()
        }, 60000)
        this.planTime = planTime
      })
    },
    handleQuit () {
      this.$router.back()
    },
    monitor_pause () {
      this.coursejilu()
    },
    monitor_timeupdate () {
      var video = document.getElementById("myVideo");
      if (!this.status) {
        video.pause()
        clearInterval(this.planTime)
        this.status = false
        this.$refs.kaoshi.init({
          id: this.$route.query.id,
          year: this.$route.query.year,
        })
      }
      let currentTime = Math.floor(video.currentTime);
      if (currentTime - this.currentTime > 5) {
        video.pause()
        video.currentTime = this.currentTime
      } else if (currentTime - this.currentTime == 1) {
        this.currentTime = currentTime
        if (this.info.tanti_time.indexOf(currentTime) != -1) {
          this.idx = this.info.tanti_time.indexOf(currentTime)
          video.pause()
          clearInterval(this.planTime)
          this.status = false
          this.$refs.kaoshi.init({
            id: this.$route.query.id,
            year: this.$route.query.year,
          })
        }
      }
    },
    monitor_ended () {
      var video = document.getElementById("myVideo");
      let keshi_shichang = Number(this.info.keshi_shichang )
      if (keshi_shichang - this.currentTime > 5) {
        return;
      }
      let currentTime = video.currentTime
      this.currentTime = currentTime
      this.savePlayPlan()
      clearInterval(this.planTime)
      Api.playOver({
        vid: this.$route.query.id,
        year: this.$route.query.year,
        study_time: currentTime,
        is_pc: 2,
      }).then(res => {
        if (res.data.code == 1) {
          if (this.$route.query.year == 2026) {
            this.show = true
          } else {
            this.$confirm(`<p style="word-break: break-all;text-align: left;">
                <span>恭喜您已完成公需科目任务！请务必登录省局<span style="color: red;">“广东省执业药师管理系统<a style="color: rgba(58, 0, 255);" target='_blank' href='https://zyys.gdfda.org/queryCredit'>https://zyys.gdfda.org/queryCredit</a>”查询公需科目学分</span><span>。</span>
              </p>`, '温馨提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: 'info',
              center: true
            }).then(() => {
              this.$router.back()
            }).catch(() => {})
          }
        } else {
          this.$confirm('本节课已学完,将跳转至课程列表选择其他课程', '温馨提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'info',
            center: true
          }).then(() => {
            this.$router.back()
          }).catch(()=>{})
        }
      })
    },
    handleLianxi () {
      window.localStorage.setItem('gx_zy', 2)
      this.$router.push('/gongxu/lianxi')
    },
    handleKaoshi () {
      window.localStorage.setItem('gx_zy', 2)
      this.$router.push('/gongxu/kaoshi')
    },
  },
}
</script>

<style lang='less' scoped>
.video-view {
  width: 70%;
  height: 70%;
  margin: 0 auto;
  .nav {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .title {
      span {
        color: @default;
      }
    }
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .myVideo {
    margin-top: 10px;
    video {
      width: 100%;
      height: 100%;
    }
  }
  .quit {
    text-align: right;
    color: #409EFF;
    margin-top: 10px;
    font-size: 20px;
    padding-bottom: 5px;
    position: relative;
    cursor: pointer;
    &::after {
      content: '';
      width: 123px;
      height: 1px;
      background: #409EFF;
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
}

.hint {
  > p {
    > span {
      color: red;
    }
  }
}
</style>